<template>
  <owa-page
    :is-showing-bandana="false"
    :is-showing-survey-notice="false"
    :is-showing-sitewide-modal="false"
  >
    <template slot="header">
      <slot name="page-header">
        <owa-page-header-simple key="header" />
      </slot>
    </template>

    <template slot="content">
      <div
        v-if="purchaseMessage"
        class="kit-wizard-messages padding-y-xl"
        style="position: sticky; offset-block-start: 0; background: var(--blue1)"
      >
        <div class="container">
          <p class="display-flex flex-row flex-items-start">
            <span>
              <font-awesome-icon
                :icon="$v7.solid.faCircleInfo"
                class="margin-top-4xs tablet:margin-top-0"
                size="lg"
              />

              <strong>{{ purchaseMessageFromQuery }}</strong>
              <span v-if="planName"> requires a {{ planName }} plan.</span>
              <span v-else>Requires a paid subscription.</span>
            </span>
          </p>
        </div>
      </div>

      <slot name="page-content">
        <main
          role="main"
          class="app-content padding-y-3xl"
        >
          <div class="container">
            <div class="laptop:margin-x-6xl">
              <div class="display-flex flex-column tablet:flex-row">
                <div :class="`purchase-${type} margin-auto margin-bottom-2xl tablet:margin-right-0 tablet:margin-bottom-0`">
                  <slot name="purchase-product" />

                  <div class="text-center">
                    <site-link :to="{ name: 'plans' }">See other Plans</site-link>
                  </div>
                </div>

                <div
                  class="purchase-form tablet:margin-right-4xl"
                  style="--hr-border-color: var(--white); --hr-border-width: var(--border-width-xs)"
                >
                  <slot name="purchase-flow" />
                </div>
              </div>

              <slot name="purchase-support" />
            </div>
          </div>
        </main>
      </slot>
    </template>

    <owa-page-footer-simple slot="footer" />
  </owa-page>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { upperFirst } from 'lodash'

  export default {
    name: 'PagePurchase',

    props: {
      type: {
        type: String,
        default: 'plan'
      },
      planName: {
        type: String,
        default: 'Pro'
      }
    },

    computed: {
      ...mapGetters('plans', ['purchaseMessage']),

      purchaseMessageFromQuery() {
        return upperFirst(this.purchaseMessage)
      }
    }
  }
</script>
